export const MODAL = {
    CANCEL: 'CANCEL',
    DELETE: 'DELETE',
    EDIT_MESSAGE: 'EDIT_MESSAGE',
    EXPORT: 'EXPORT',
    KITCHEN_LINK: 'KITCHEN_LINK',
    MESSAGE: 'MESSAGE',
    ORDER_HISTORY: 'ORDER_HISTORY',
    ORDER_SUMMARY: 'ORDER_SUMMARY',
    ORDER_PAYMENT: 'ORDER_PAYMENT',
    PICKING_LIST_PDF: 'PICKING_LIST_PDF',
    PRICE_SUMMARY: 'PRICE_SUMMARY',
    QUESTIONNAIRE: 'QUESTIONNAIRE',
    SHARE: 'SHARE',
    PAYMENT_REGISTER: 'PAYMENT_REGISTER',
    PAYMENT_HISTORY: 'PAYMENT_HISTORY',
    DOCUSIGN: 'DOCUSIGN',
    EXTRA_NEEDS: 'EXTRA_NEEDS',
} as const;

export type ModalType = (typeof MODAL)[keyof typeof MODAL];

export interface ActionModalProps {
    visible: boolean;
    onClose: () => void;
}
